/**
 * Created By Alon Yampolski on 28/3/18
 */

export * from './copyright-params.selector';
